@if (loading) {
  <div id="loader-wrapper">
    <div id="loader"><div></div><div></div><div></div><div></div><div></div></div>
  </div>
}

<iframe #frame (load)="onFrameLoad(frame)" [src]="iframeSrc | safeHtml" class="room-frame" frameborder="0" allow="camera *;microphone *;display-capture *;fullscreen *"></iframe>